import React, { createContext, useContext, useState } from 'react';

export const AnnouncementBarContext = createContext({
  isVisible: false,
  height: 0,
  setIsVisible: () => {},
  setHeight: () => {}
});

export const useAnnouncementBar = () => useContext(AnnouncementBarContext);

export const AnnouncementBarProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [height, setHeight] = useState(0);

  return (
    <AnnouncementBarContext.Provider value={{ isVisible, height, setIsVisible, setHeight }}>
      {children}
    </AnnouncementBarContext.Provider>
  );
};

